import React from 'react';
import { Container, Row, Col, Card, CardHeader, Button, CardBody, CardText, Modal, ModalHeader, ModalBody, Form, Input, FormGroup, Label, FormFeedback } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import { ip } from '../../Auxiliares/ip'
import ValidarAspiranteCard from '../../Componentes/Cards/validarAspiranteCard'
//import Tarjeta from '../../Componentes/Cards/validarCard'
//import history from '../../Historial'

export default class InicioAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            asignacion: [],
            asignados: [],
            isViewModalOpen: null,
            isEmailModalOpen: null,
            nombre: null,
            disable: false,
            ruta: null,
            mensajeCorreo: '',
            documento: '',
            disableEnviar: false,
            esExtranjero: false,
            ficha: '',
            estado: '',
            listadoFichas: [],
            documentos: [
                { nombre: 'Solicitud de inscripción', ref: null },
                { nombre: 'Acta de nacimiento', ref: null },
                { nombre: 'CURP', ref: null },
                { nombre: 'Fotografía', ref: null },
                { nombre: 'Comprobante de pago de inscripción', ref: null },
                { nombre: 'Certificado de bachillerato (En caso de contar con ello)', ref: null },
                { nombre: 'Formato FMM', ref: null },
                { nombre: 'Contrato estudiantil', ref: null },
                { nombre: 'Número de seguro social', ref: null },
                // { nombre: 'Certificado parcial de licenciatura', ref: null },
                // { nombre: 'Certificado de licenciatura', ref: null },
                // { nombre: 'Dictamen de revalidación o equivalencia de estudios', ref: null }
            ],
            currentPage: 1, //pagination
            elementsPerPage: 150, //pagination 150 por no tener barra de busqueda
        }
        this.handleClick = this.handleClick.bind(this);

        this.actualizarLista = this.actualizarLista.bind(this)
        this.dateToString = this.dateToString.bind(this)
        this.borrar = this.borrar.bind(this);
        this.buscar = this.buscar.bind(this);
    }

    //pagination
    handleClick(event) {
        this.actualizarLista()
        this.setState({
            currentPage: Number(event.target.id)
        });
    }
    //pagination 

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    handleKeyPress = e => {
        if (e.key === "Enter") {
            this.buscar();
        }
    }

    buscar() {

        const { listadoFichas, ficha, estado } = this.state
        var fichas = listadoFichas;

        console.log(fichas, ficha, estado)

        if (ficha === '' && estado === '') {
            this.actualizarLista()
        } else {

            Fetch('/buscarAspirantes', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ fichas, ficha, estado })
            })
                .then(response => {
                    this.setState({ asignados: response.data })
                })
                .catch(err => {
                    switch (err.status) {
                        case 600:
                            toast.error('Datos no encontrados')
                            break;
                        case 400:
                            toast.info('No existen coincidencias')
                            break;
                        default:
                            toast.error("Se produjo un error de conexion")
                            break;
                    }
                })
        }
    }

    borrar() {
        this.setState({
            ficha: '',
            estado: ''
        })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    componentDidMount() {
        this.actualizarLista()
    }

    dateToString(fecha) {
        var date = new Date(fecha);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }
    actualizarLista() {
        Fetch('/api/getOwnAsignacion', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: sessionStorage.getItem('_id') })
        })
            .then(response1 => {
                this.setState({ asignacion: response1.data[0] })

                Fetch('/api/getAspirantesDeAsignacion', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ lista: response1.data[0].lista })
                })
                    .then(response2 => {
                        this.setState({ asignados: response2.data, listadoFichas: response1.data[0].lista })
                    })
                    .catch(err => {
                        switch (err.status) {

                            case 600:
                                console.log('Error inesperado')
                                break;

                            case 605:
                                console.log('Listado de elementos vacia')
                                this.setState({ asignados: [] })
                                break;

                            default:
                                break;
                        }
                    })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ asignacion: [] })
                        break;

                    default:
                        break;
                }
            })

    }


    render() {

        //pagination
        const { asignados, currentPage, elementsPerPage } = this.state;

        const indexOfLastTodo = currentPage * elementsPerPage;
        const indexOfFirstTodo = indexOfLastTodo - elementsPerPage;
        const currentAsignados = asignados.slice(indexOfFirstTodo, indexOfLastTodo);

        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(asignados.length / elementsPerPage); i++) {
            pageNumbers.push(i);
        }
        //pagination

        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <h1 class="mt-4 mb-4 text-center">Aspirantes</h1>

                                <div className="p-4">
                                    <Container>
                                        {/*<Card className="p-4">
                                            <Form>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <Label>Ficha</Label>
                                                            <Input type="text" name="ficha" className="col-11" onChange={this.setValue.bind(this, "ficha")} onKeyPress={this.handleKeyPress} value={this.state.ficha} />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col>
                                                        <FormGroup>
                                                            <Label>Filtrar por estado</Label>
                                                            <Input type="select" name="estado" className="col-11" onChange={this.setValue.bind(this, "estado")} onKeyPress={this.handleKeyPress} value={this.state.estado}>
                                                                <option></option>
                                                                <option>Todos Vacios</option>
                                                                <option>Todos Cargados</option>
                                                                <option>Todos Revision</option>
                                                                <option>Todos Aceptados</option>
                                                                <option>Todos Rechazados</option>
                                                                <option>Existan Vacios</option>
                                                                <option>Existan Cargados</option>
                                                                <option>Existan Revision</option>
                                                                <option>Existan Aceptados</option>
                                                                <option>Existan Rechazados</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>

                                                </Row>

                                                <Row className="mt-3">
                                                    <Col className="text-left">
                                                        <Button className="w-25 bg-info mr-3" onClick={this.buscar}>Buscar</Button>
                                                        <Button className="w-25 bg-dark ml-3" onClick={this.borrar}>Limpiar</Button>
                                                    </Col>
                                                </Row>

                                            </Form>
                                        </Card>*/}

                                        <Row>
                                            {currentAsignados.length > 0 ? currentAsignados.map((value) => (
                                                <Col className="col-4">
                                                    <ValidarAspiranteCard ficha={value.ficha} curp={value.curp} nacionalidad={value.nacionalidad} nombre={value.nombre} ap_paterno={value.ap_paterno} ap_materno={value.ap_materno} />
                                                </Col>
                                            )) : <Col>
                                                    <Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >No existe perfil de asignación, consulte al administrador</Card>
                                                </Col>}
                                        </Row>
                                        <div style={{ overflowX: 'scroll' }}>
                                            <ul class="pagination" style={{
                                                whiteSpace: 'nowrap', cursor: 'pointer'
                                            }}>
                                                {pageNumbers.map((number) => (
                                                    <li style={{ display: 'inline-block', width: '50px', textAlign: 'center' }}
                                                        className={number == this.state.currentPage ? "page-item active" : "page-item"}>
                                                        <a class="page-link"
                                                            key={number}
                                                            id={number}
                                                            onClick={this.handleClick}
                                                        >
                                                            {number}
                                                        </a>
                                                    </li>))}
                                            </ul>
                                        </div>
                                    </Container>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Footer />
            </html>
        )
    }
}
